import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageMasterDataConfigComponent } from './manage-master-data-config/manage-master-data-config.component';
import { ManageMasterDataComponent } from './manage-master-data/manage-master-data.component';
import { SearchMasterDataComponent } from './search-master-data/search-master-data.component';
const routes: Routes = [
  {
    path: '',
    component: ManageMasterDataConfigComponent,
  },
  {
    path: 'manage-master-data/:category',
    component: ManageMasterDataComponent,
  },
  {
    path: 'search',
    component: SearchMasterDataComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterDataRoutingModule { }
